import { cn } from "src/common/utils";

const NewRelicIcon = ({ className }: { className?: string }) => (
  <div className={cn(className, "bg-white rounded-sm p-1")}>
    <svg
      viewBox="0 0 178 178"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M131.85 65.03V113.94L89.5 138.4V168.97L158.33 129.23V49.74L131.85 65.03Z"
        fill="#00AC69"
      />
      <path
        d="M63.35 153.94L63.35 105.03L21 80.57L21 50L89.83 89.74L89.83 169.23L63.35 153.94Z"
        fill="#1D252C"
      />
      <path
        d="M89.4999 40.58L131.85 65.03L158.33 49.74L89.4999 10L20.6599 49.74L47.1399 65.03L89.4999 40.58Z"
        fill="#1CE783"
      />
    </svg>
  </div>
);

export default NewRelicIcon;
